'use client';

import { useIntl } from 'react-intl';
import { Notification } from '@packages/shared/src/ui/Notification/Notification';
import { Button } from '@packages/shared/src/ui/Button/Button';

export const OfflineNotification = () => {
  const { formatMessage } = useIntl();

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="px-2 pb-2">
      <Notification severity="warning" variant="outline">
        <div className="flex flex-col gap-2">
          <p>
            {formatMessage({
              id: 'MyAccount.DefaultOffline.Notification',
              defaultMessage:
                'Entschuldigung, wir können deine Daten zur Zeit leider nicht anzeigen. Falls der Fehler nach einem Neuladen der Seite weiterhin besteht, haben wir intern ein technisches Problem und sind bereits dabei es zu beheben. Versuche es dann später noch einmal. Vielen Dank für dein Verständnis.',
            })}
          </p>
          <Button onClick={handleReload} variant="link" className="self-start">
            {formatMessage({
              id: 'MyAccount.ReloadPage.Button',
              defaultMessage: 'Seite neu laden',
            })}
          </Button>
        </div>
      </Notification>
    </div>
  );
};
